import React from "react";
import { addPackageModal } from "../../redux/actions/sidebar/sidebarAction";
import { store } from "../../redux/storeConfig/store";
import { voiceReviewActionLabel } from "../voiceAdd/saveDraftEdit";

export const StepButton = (props) => {
  const { step } = props;
  switch (step) {
    case 1:
      return (
        <>
          <div className="bg-white card-panel ex-space-y pt-0">
            <div className="action-wrapper blk-padding-y">
              <div className="action-inner-block">
                <div className="action-btn-block">
                  <button
                    className="btn btn-medium btn-transparent"
                    type="button"

                    onClick={() => {
                      store.dispatch(addPackageModal(false));
                      // history.push("/gym-panel/memberslist");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    value="Add Package"
                    className="btn btn-medium"
                    type="submit"
                  >
                    {voiceReviewActionLabel(
                      store.getState().sidebar.packageEdit
                        ? "Save package"
                        : "Add package"
                    )}
                  </button>{" "}
                </div>
              </div>
            </div>
          </div>
        </>
      );
  }
};
